import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { AgregarDomicilioPersonaParams, AgregarDomicilioPersonaResponse, AgregarPersonaParams, AgregarPersonaResponse, BuscarPersonaParams, defaultAgregarDomicilioPersona, defaultAgregarPersona, PersonaProps } from '../../interfaces/comun/PersonaInterface';
import { DomicilioProps } from '../../interfaces/comun/DomicilioInterface';

export const BuscarPersona = ( params: BuscarPersonaParams ) => {

    return new Promise<PersonaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Persona/BuscarPersona', params, token)
            .then( ({ data } : { data : PersonaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarPersona = ( params: AgregarPersonaParams ) => {

    return new Promise<AgregarPersonaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Persona/AgregarPersona', params, token)
            .then( ({ data } : { data : AgregarPersonaResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultAgregarPersona, message: error.message } );
            });

        }

    });

}

export const ObtenerDomicilioPersona = ( id: number ) => {

    return new Promise<DomicilioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Persona/ObtenerDomicilioPersona/${ id }`, token)
            .then( ({ data } : { data : DomicilioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarDomicilioPersona = ( params: AgregarDomicilioPersonaParams ) => {

    return new Promise<AgregarDomicilioPersonaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Persona/AgregarDomicilioPersona', params, token)
            .then( ({ data } : { data : AgregarDomicilioPersonaResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultAgregarDomicilioPersona, message: error.message } );
            });

        }

    });

}
